import React, { useCallback, useRef, useState, forwardRef, useImperativeHandle, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./ImmunizationInfluenzaViewNew.module.css";

import { AddButton, InputBox, CheckboxItem } from "@cpnw/ui";
import DashboardRadio from "components/DashboardRadio";
import FormDatePicker from "components/FormDatePicker";
import { DATE_FORMAT_PATTERN } from "pages/enums";

const ImmunizationInfluenzaViewNew = forwardRef(({
  data = {},
  onChange,
  disabled = false,
  onValidate }, ref) => {

  const [vaccineDates, setVaccineDates] = useState(data.vaccineDates || [{}]);
  const [error, setError] = useState('');

  useImperativeHandle(ref, () => ({
    validator: () => {
      const errors = {};
      setError('');
      data.vaccineDates = vaccineDates.filter(
        (entry) => entry.immunizationDate || (entry.location || "").trim()
      );
      setVaccineDates(data.vaccineDates.length ? data.vaccineDates : [{}]);
      onValidate({});
      return null; // No errors
    },
  }));

  const setValue = (key, value) => {
    if (key) {
      data[key] = value;
    }

    console.log('data after setValue', data);

    if (onChange) {
      onChange({ ...data });
    }
  };

  return (
    <>
      <div className={styles.container}>
        {vaccineDates.map((date, index) => (
          <div className={styles.testRow} key={index}>
            <FormDatePicker
              label="Immunization Date"
              dateFormat={DATE_FORMAT_PATTERN}
              dateString={date.immunizationDate}
              setDate={(dateString) => {
                const newDates = [...vaccineDates];
                newDates[index].immunizationDate = dateString;
                setVaccineDates(newDates);
                setValue("vaccineDates", newDates);
              }}
              disabled={disabled}
            />

            <div className={styles.column}>
              <InputBox
                label="Location Received"
                placeholder="Provider Name & Location"
                value={date.location || ""}
                setValue={(e) => {
                  const newDates = [...vaccineDates];
                  newDates[index].location = e.target.value;
                  setVaccineDates(newDates);
                  setValue("vaccineDates", newDates);
                }}
                disabled={disabled}
              />
            </div>
            {!disabled && (
              <button
                type="button"
                className={styles.removeButton}
                aria-label="Remove"
                onClick={() => {
                  const newDates = vaccineDates.filter((_, i) => i !== index);
                  setVaccineDates(newDates);
                  setValue("vaccineDates", newDates);
                }}
              >
                x
              </button>
            )}
          </div>
        ))}
        {!disabled && (
          <div className={styles.addButtonContainer}>
            <AddButton
              onClick={() => setVaccineDates([...vaccineDates, {}])}
              label="Seasonal Vaccination"
            />
          </div>
        )}
      </div>
    </>
  );
})

export default ImmunizationInfluenzaViewNew;
